import {NgModule} from '@angular/core';
import {AsaxHeaderComponent} from './asax-header.component';
import {SearchModule} from './search/search.module';
import {DownloadModule} from './download/download.module';
import {ShareModule} from './share/share.module';
import {HelpModule} from './help/help.module';
import {HeaderFiltersModule} from './header-filters/header-filters.module';

@NgModule({
  declarations: [
    AsaxHeaderComponent,
  ],
  imports: [
    HeaderFiltersModule,
    SearchModule,
    ShareModule,
    HelpModule,
    DownloadModule
  ],
  exports: [
    AsaxHeaderComponent
  ]
})
export class AsaxHeaderModule {
}
